import * as React from "react"
import Svg, { Path } from "react-native-svg"

function RightArrow(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <Path
                d="M12.001 19.1c-.03 0-.055-.005-.1-.05-.045-.045-.05-.07-.05-.1 0-.016.002-.03.009-.045l.04-.056 6.7-6.7H4.751c-.071 0-.094-.017-.113-.036-.02-.02-.036-.042-.036-.114 0-.071.017-.093.036-.113.02-.02.042-.036.113-.036H18.6l-6.725-6.725a.065.065 0 01-.016-.023.146.146 0 01-.007-.053c0-.03.004-.055.049-.1.045-.045.07-.05.1-.05.016 0 .03.002.045.009l.056.04 6.95 6.95.042.05a.13.13 0 01.008.051l-.008.053-.042.048-6.974 6.976a.066.066 0 01-.024.016.139.139 0 01-.053.008z"
                fill={props.color || "#1C2024"}
                stroke={props.color || "#1C2024"}
                strokeWidth={1.2}
            />
        </Svg>
    )
}

export default RightArrow
